import MessageRouteFactory from './Factory'

exports.MessageRouteFactory = MessageRouteFactory
